import {Pipe, PipeTransform} from '@angular/core';
import {forkJoin, Observable, of} from 'rxjs';
import { map } from 'rxjs/operators';
import {RemoteMappingItem} from '../interfaces/remote-mapping-item';
import {MappingService} from '../services/mapping.service';

type mappingType = 'destination' | 'itinerary' | 'parentDestination' | 'basis' | 'airportId' | 'airportCode';

@Pipe({
  name: 'getDataFromMapping'
})
export class GetDataFromMappingPipe implements PipeTransform {

  private mappingType = {
    destination: 'getDestinationByID',
    itinerary: 'getItineraryById',
    parentDestination: 'getParentDestinationByID',
    basis: 'getBasisByID',
    top: 'getTourOperatorByID',
    airportId: 'getAirportByID',
    airportCode: 'getAirportByCode'
  };

  constructor(private _mappingService: MappingService) { }

  transform(value: number | number[], type: mappingType): Observable<any> {
    if (Array.isArray(value)) {
      const subs: Observable<RemoteMappingItem>[] = [];
      value.forEach((item) => {
        subs.push(this._mappingService[this.mappingType[type]](item)!);
      });

      return value ? forkJoin(subs).pipe(map((response) => response)) : of([{ Name: null, Id: null } as RemoteMappingItem]);
    } else {
      if(typeof value === 'string' &&( this._mappingService[this.mappingType[type]](value) !== null && value !== 'null')){
        return this._mappingService[this.mappingType[type]](value)
      } else if(typeof value === 'number'){
        return this._mappingService[this.mappingType[type]](value)
      } else {
        return of({Name: "Solo soggiorno", Id: null});
      }
    }
  }

}
